<script>
  import { logout } from "../scripts/firebase.js";
  import {
    user,
    pageToLoad,
    userWorkshops,
    selectedWorkshopID,
  } from "../scripts/stores.js";
  import { formatTimestamp, formatTimeRange } from "../scripts/utils.js";
  import { updateSubs } from "../scripts/pages.js";

  console.log("in the dashboard");

  let workshopsArrayNew;
  let areWorkshops = false;

  // TODO put workshops in order chronologically
  $: {
    workshopsArrayNew = Object.values($userWorkshops);
    console.log(workshopsArrayNew);
    areWorkshops = workshopsArrayNew.length > 0;
  }

  const logoutLocal = async () => {
    await logout();
    pageToLoad.set("home");
  };

  const loadDetails = (id) => {
    selectedWorkshopID.set(id);
    pageToLoad.set("workshopDetail");
  };

  $: $user.loggedIn && updateSubs(true, "register");
</script>

<main class="page">
  <div class="welcome-row">
    <span><h1>Welcome {$user.displayName}!</h1></span>
    <span class="link-internal" on:click={logoutLocal}>Logout</span>
  </div>

  {#if areWorkshops}
    <p>Here are the workshops you're signed up for:</p>
    {#each workshopsArrayNew as { title, startTime, endTime, id }}
      <div class="ws-item">
        <h3>{title}</h3>
        <h4>{formatTimestamp(startTime).date}</h4>
        <h4>{formatTimeRange(startTime, endTime)}</h4>
      </div>
      <div class="button-primary" on:click={() => loadDetails(id)}>Details</div>
    {/each}
  {:else}
    <p>Your information is loading...</p>
  {/if}
</main>

<style>
  .ws-item {
    border-top: 1px #bbb solid;
    padding: 10px;
  }
  .welcome-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
